import { createEmojiIcon } from '../EmojiIcon';

export const VideocamIcon = createEmojiIcon('🎥');
export const VideocamOffIcon = createEmojiIcon('🚫');
export const FiberManualRecordIcon = createEmojiIcon('⏺');
export const StopIcon = createEmojiIcon('⏹');
export const StopRoundedIcon = createEmojiIcon('⏹');
export const PauseIcon = createEmojiIcon('⏸');
export const PlayArrowIcon = createEmojiIcon('▶');
export const ReplayIcon = createEmojiIcon('🔁');
export const BlockIcon = createEmojiIcon('🚫');
export const RecIndicatorIcon = createEmojiIcon('⏺');
export const VolumeOffIcon = createEmojiIcon('🔇');
export const VolumeUpIcon = createEmojiIcon('🔊');
